<template>
  <div class="modal register-modal">
    <div class="overlay" @click="$parent.closeRegister"></div>

    <div class="wrapper">
      <img
        class="close"
        @click="$parent.closeRegister"
        src="./../images/close.svg"
      />

      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">Create account</div>
                <label>
                  <input type="text" placeholder="First name" v-model="name" />
                </label>
                <label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    v-model="surname"
                  />
                </label>
                <label>
                  <input type="email" placeholder="Email" v-model="email" />
                </label>
                <label>
                  <input type="text" placeholder="Phone" v-model="phone" />
                </label>
                <label>
                  <input
                    type="date"
                    placeholder="Birthdate"
                    v-model="birthdate"
                  />
                  <div v-if="ageError" class="desc red" style="margin-top: 4px;">
                    {{ ageError }}
                  </div>
                </label>
                <label>
                  <input type="text" placeholder="Address" v-model="address" />
                </label>
                <label>
                  <input type="text" placeholder="City" v-model="city" />
                </label>
                <label>
                  <input
                    type="text"
                    placeholder="Post code"
                    v-model="post_code"
                  />
                </label>
                <label>
                  <!-- <Select2 class="select2 single" v-model="country"
                           :options="countryOptions"
                           @select="selectCountry($event)"
                           placeholder="Country"
                  /> -->
                  <select v-model="country">
                    <option disabled selected value="">Country</option>
                    <option
                      v-for="(item, i) in countryOptions"
                      :value="item"
                      :key="i"
                    >
                      {{ item.title }}
                    </option>
                  </select>
                </label>
                <label>
                  <input
                    type="password"
                    placeholder="Password"
                    v-model="pass"
                  />
                </label>
                <label>
                  <input
                    type="password"
                    placeholder="Confirm Password"
                    v-model="passConfirm"
                  />
                </label>
                <div class="link-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="desc">I have read and agreed to the</span>
                        <a @click="$parent.goToPrivacy()" class="desc link">
                          Privacy Policy</a
                        >
                        <span class="desc"> and </span>
                        <a @click="$parent.goToTerms()" class="desc link">
                          Terms and Conditions</a
                        >
                      </div>
                    </label>
                  </div>
                </div>
                <div class="link-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="old" v-model="old" />
                        <div class="checkbox"></div>
                        <span class="desc">I am 18 years old or older</span>
                      </div>
                    </label>
                  </div>
                </div>
                <button
                  :class="[
                    'button',
                    'black',
                    { disabled: !requiredRegisterFieldsAreFilled },
                  ]"
                  @click="submitRegister"
                >
                  <span>Create Account</span>
                </button>
                <div class="desc link" @click="$parent.openSignInModal">
                  Sign In!
                </div>
                <div v-if="$parent.error" class="desc red">
                  {{ $parent.error }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Select2 from "vue3-select2-component";

export default {
  name: "RegisterModal",
  props: [],
  components: {
    // Select2
  },
  data: function () {
    return {
      email: "",
      name: "",
      surname: "",
      phone: "",
      pass: "",
      passConfirm: "",
      birthdate: "",
      address: "",
      city: "",
      post_code: "",
      country: "",
      countryOptions: [],
      countryOptionsId: [],
      terms: false,
      old: false,
    };
  },
  mounted() {
    this.getCountries();
  },
  computed: {
    ageError() {
      if (!this.birthdate) return null;
      const today = new Date();
      const birth = new Date(this.birthdate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age < 18 ? 'We accept users 18 years old or over' : null;
    },
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        this.pass &&
        this.passConfirm &&
        this.address &&
        this.city &&
        this.post_code &&
        this.country &&
        this.birthdate &&
        !this.ageError &&
        this.terms &&
        this.old
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  methods: {
    selectCountry(event) {
      this.country = event.text;
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i] == event.text) {
          this.countryId = this.countryOptionsId[i];
        }
      }
    },
    getCountries() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    submitRegister() {
      let regData = {
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        email: this.email,
        password: this.pass,
        passConfirm: this.passConfirm,
        address: this.address,
        city: this.city,
        post_code: this.post_code,
        country_id: this.country.id,
        birth_date: this.birthdate,
      };
      this.$emit("registration", regData);
    },
  },
};
</script>
